export interface UnlinkAccount {
    account_code: string;
    email_address: string;
    user_id: string;
}

export class UnlinkAccount implements UnlinkAccount { }
